import { StoreState } from 'state/types';
import { CreateTimesheetDialogReducerState } from './types';

const getState = (state: StoreState): CreateTimesheetDialogReducerState => state.createTimesheetDialog;

export const getCreateTimesheetParams = (state: StoreState) => getState(state).params;
